import { render, staticRenderFns } from "./store-type-selector.vue?vue&type=template&id=68c6efe4"
import script from "./store-type-selector.vue?vue&type=script&lang=js"
export * from "./store-type-selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports